// import Service from "../../../service/api"

const ScoreModule = {
    namespaced: true,
    state: {
        point: 0,
    },
    mutations: {
        setPoint(state) {

            state.point += 1
        },
        setDefaultPoint(state) {
            state.point = 0
        }
    },
    getters: {
        getPoint(state) {
            return state.point
        },
    }
}

export default ScoreModule;